import '../common/MedDevice.css'
import { useEffect, useMemo, useRef, useState } from "react"
import { Box } from "@mui/material"
import { deviceIcon } from "../../../../icons"
import { useAppDispatch } from "../../../../redux/store"
import PageHeader from "../../../../components/PageHeader"
import { getDevices } from "../../../../services/medsDevicesService"
import { Device } from "../../../corp/devices/types"
import { addError } from "../../../../redux/alerts"
import constants from "../../../../constants"
import { trackPromise } from 'react-promise-tracker'
import useCustomerNumber from '../../../../hooks/useCustomerNumber'
import useCustomer from '../../../../hooks/useCustomer'
import SalesPage from '../common/SalesPage'
import MedsDevicesContainer from '../common/MedsDevicesContainer'
import { LoadingState } from '../../../../types'
import { KitType } from '../common/enums'

const Devices = () => {
  const dispatch = useAppDispatch()
  const contentRef = useRef<HTMLDivElement>(null)

  const customer = useCustomer()
  const customerNumber = useCustomerNumber()

  const [devices, setDevices] = useState<Device[]>([])
  const [loading, setLoading] = useState<LoadingState>(LoadingState.NotStarted)

  const compliance = useMemo(() => {
    if (!customer.customerMetadata) return null;

    return {
      message_long: customer.customerMetadata.device_message_long,
      compliance_status: customer.customerMetadata.device_status,
    }
  }, [customer.customerMetadata])  

  useEffect(() => {
    if (customerNumber) {
      trackPromise(fetchDevices(customerNumber))
    }
  }, [customerNumber])

  const fetchDevices = async (customerNumber: string) => {
    try {
      setLoading(LoadingState.Loading)

      const devices: Device[] = await getDevices(customerNumber)

      setDevices(devices)
      setLoading(LoadingState.Done)
    } catch (err) {
      console.error(err)
      dispatch(addError('Could not get Devices, please try again later.'))
      setLoading(LoadingState.Error)
    }
  }  

  return (
    <Box ref={contentRef}>
      <PageHeader src={deviceIcon} headerName="Devices" />
      {
        Boolean(devices.length) && loading === LoadingState.Done && (
          <MedsDevicesContainer
            type={KitType.Device}
            items={devices}
            header="AEDs and Devices"
            label="AEDs and Devices"
            image="chart-device"
            compliance={compliance}
            contentRef={contentRef}
            fetchItems={fetchDevices}
          />
        )
      }
      {
        devices.length === 0 && loading === LoadingState.Done && (
          <SalesPage
            src={constants.DEVICES_SALES_PAGE_URL}
            title="Devices"
          />
        )
      }
    </Box>
  )
}

export default Devices